import { useBillingContext } from '../context/billingContext';
import { getTotalQuantity } from '../utils';

export const Header = () => {
  const { billingItems } = useBillingContext();
  return (
    <div className="flex items-center gap-2">
      <span className="txt-extra-large-bold">Your cart</span>
      <div className="size-1 bg-fg-quinary rounded-full" />
      <span className="txt-extra-large-regular">
        {getTotalQuantity(billingItems)} items
      </span>
    </div>
  );
};
